import type { IconData } from '@stacksjs/iconify-core'

export const padlockAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M6 18a4 4 0 1 0 0-8a4 4 0 0 0 0 8M2 9.528V4a4 4 0 1 1 8 0v5.528a6 6 0 1 1-8 0M4 8.34A6 6 0 0 1 6 8c.701 0 1.374.12 2 .341V4a2 2 0 1 0-4 0v4.341zM6 16a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default padlockAlt
